import React, { useEffect } from 'react';

/**
 * JsonLd — Injects a <script type="application/ld+json"> into <head> for SEO
 * structured data. Removes the tag on unmount so multiple pages don't pile up.
 */
const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return undefined;
    const scriptId = `jsonld-${id}`;
    let s = document.getElementById(scriptId);
    if (!s) {
      s = document.createElement('script');
      s.type = 'application/ld+json';
      s.id = scriptId;
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(data);
    return () => {
      const el = document.getElementById(scriptId);
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
  }, [id, data]);
  return null;
};

export default JsonLd;
